import { render, staticRenderFns } from "./businessProcess.vue?vue&type=template&id=51139140&scoped=true"
import script from "./businessProcess.vue?vue&type=script&lang=js"
export * from "./businessProcess.vue?vue&type=script&lang=js"
import style0 from "./businessProcess.vue?vue&type=style&index=0&id=51139140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51139140",
  null
  
)

export default component.exports